/**
 * @generated SignedSource<<65b044e929132e727fd57f2e3235b1ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type useWidgetTaskSingleSections_widgetTaskSingle$data = {
  readonly activeSectionVersions: ReadonlyArray<{
    readonly id: string;
    readonly ordinal: number;
    readonly section: {
      readonly assignedTeam: {
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
    };
    readonly title: string | null;
  }>;
  readonly " $fragmentType": "useWidgetTaskSingleSections_widgetTaskSingle";
};
export type useWidgetTaskSingleSections_widgetTaskSingle$key = {
  readonly " $data"?: useWidgetTaskSingleSections_widgetTaskSingle$data;
  readonly " $fragmentSpreads": FragmentRefs<"useWidgetTaskSingleSections_widgetTaskSingle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useWidgetTaskSingleSections_widgetTaskSingle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSectionVersion",
      "kind": "LinkedField",
      "name": "activeSectionVersions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ordinal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTaskSingle",
  "abstractKey": null
};
})();

(node as any).hash = "549e866f8e1b73ef5802224f1f648fac";

export default node;
